import { Tabs } from 'antd';
import { DefaultTabStyled } from 'components/Tab/styled';
import React, { useEffect, useState } from 'react';
import BaseLayout from 'routes/Users/components/UsersList/UserDetailDrawer/BaseLayout';
import { GeneralFunction } from 'types/common';
import { ILocation } from 'types/location';

import { getTabs } from './helpers';
import { ILocationTabsData } from './types';

const { TabPane } = Tabs;

const LocationSlideIn: React.FC<{
  refetchLocationData: GeneralFunction;
  location?: ILocation;
}> = ({ location, refetchLocationData }) => {
  const components = getTabs();
  const [activeTabKey, setActiveTabKey] = useState<string>('0');

  useEffect(() => {
    setActiveTabKey('0');
  }, [location]);

  const onTabClick = (key: string) => {
    setActiveTabKey(key);
  };

  const generateTabContents = (content: ILocationTabsData, index: number) => {
    if (!location) return null;
    return (
      <TabPane tab={content.title} key={index}>
        <BaseLayout style={{ padding: 0 }}>
          <content.component
            // setUserInputValues={setUserInputValues}
            location={location}
            refetchLocationData={refetchLocationData}
          />
        </BaseLayout>
      </TabPane>
    );
  };

  return (
    <DefaultTabStyled
      onTabClick={(key) => {
        onTabClick(key);
      }}
      activeKey={activeTabKey}>
      {components.map(generateTabContents)}
    </DefaultTabStyled>
  );
};

export default React.memo(LocationSlideIn);
